<template>
    <div class="row">
        <div class="col-12">
            <div class="resultado-container">
                <div class="resultado-header d-flex justify-content-between align-items-center">
                    <span><i class="fas fa-chart-bar me-2"></i>{{$t('result')}}</span>
                    <button class="btn-chart-toggle" @click="showChart = !showChart" :title="showChart ? 'Esconder gráfico' : 'Ver gráfico'">
                        <i class="fas" :class="showChart ? 'fa-table' : 'fa-chart-bar'"></i>
                        <span class="ms-1">{{ showChart ? 'Tabela' : 'Gráfico' }}</span>
                    </button>
                </div>
                <!-- CHART OVERLAY -->
                <div v-if="showChart" class="chart-overlay" @click.self="showChart = false">
                    <div class="chart-modal">
                        <div class="chart-modal-header">
                            <span><i class="fas fa-chart-bar me-2"></i>Gráfico de Resultados</span>
                            <button class="btn-chart-close" @click="showChart = false"><i class="fas fa-times"></i></button>
                        </div>
                        <div class="chart-modal-body">
                            <canvas ref="resultadosChartCanvas"></canvas>
                        </div>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table resultado-table text-center mb-0">
                        <thead>
                        <tr>
                            <th class="text-start col-label"></th>
                            <th class="col-atual">{{$t('current')}}</th>
                            <th>{{$t('first')}}</th>
                            <th>{{$t('previous')}}</th>
                            <th>{{$t('currentPrevious')}}</th>
                            <th>{{$t('currentFirst')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="text-start row-label">{{$t('totalBodyWeight') || $t('weight')}}</td>
                            <td class="col-atual"><span class="valor-destaque">{{ state.composicaoAtual.weight }}</span></td>
                            <td>{{ state.composicaoPrimeira.weight }}</td>
                            <td>{{ state.composicaoAnterior.weight }}</td>
                            <td><span :class="diffClass(state.composicaoAnterior.weight === 0 ? 0 : state.composicaoAtual.weight - state.composicaoAnterior.weight)">{{ state.composicaoAnterior.weight === 0 ? 0 : state.composicaoAtual.weight - state.composicaoAnterior.weight }}</span></td>
                            <td><span :class="diffClass(state.composicaoPrimeira.weight === 0 ? 0 : state.composicaoAtual.weight - state.composicaoPrimeira.weight)">{{ state.composicaoPrimeira.weight === 0 ? 0 : state.composicaoAtual.weight - state.composicaoPrimeira.weight }}</span></td>
                        </tr>
                        <tr>
                            <td class="text-start row-label">% {{$t('fat')}}</td>
                            <td class="col-atual"><span class="valor-destaque">{{ parseFloat(state.composicaoAtual.fat_percentage) }}</span></td>
                            <td>{{ parseFloat(state.composicaoPrimeira.fat_percentage).toFixed(2) }}</td>
                            <td>{{ parseFloat(state.composicaoAnterior.fat_percentage).toFixed(2) }}</td>
                            <td>
                                <span :class="diffClass(state.composicaoAnterior.fat_percentage === 0 ? 0 : parseFloat(state.composicaoAtual.fat_percentage) - parseFloat(state.composicaoAnterior.fat_percentage))">
                                {{ state.composicaoAnterior.fat_percentage === 0 ? 0 :
                                  (parseFloat(state.composicaoAtual.fat_percentage) - parseFloat(state.composicaoAnterior.fat_percentage)).toFixed(2)
                                }}
                                </span>
                            </td>
                            <td>
                                <span :class="diffClass(state.composicaoPrimeira.fat_percentage === 0 ? 0 : parseFloat(state.composicaoAtual.fat_percentage) - parseFloat(state.composicaoPrimeira.fat_percentage))">
                                {{ state.composicaoPrimeira.fat_percentage === 0 ? 0 :
                                  (parseFloat(state.composicaoAtual.fat_percentage) - parseFloat(state.composicaoPrimeira.fat_percentage)).toFixed(2)
                                }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-start row-label">{{$t('fatWeight') || $t('fat')}}</td>
                            <td class="col-atual"><span class="valor-destaque">{{ state.composicaoAtual.fat_weight }}</span></td>
                            <td>{{ state.composicaoPrimeira.fat_weight }}</td>
                            <td>{{ state.composicaoAnterior.fat_weight }}</td>
                            <td>
                                <span :class="diffClass(state.composicaoAnterior.fat_weight === 0 ? 0 : parseFloat(state.composicaoAtual.fat_weight) - parseFloat(state.composicaoAnterior.fat_weight))">
                                {{ state.composicaoAnterior.fat_weight === 0 ? 0 : (parseFloat(state.composicaoAtual.fat_weight) - parseFloat(state.composicaoAnterior.fat_weight)).toFixed(2) }}
                                </span>
                            </td>
                            <td>
                                <span :class="diffClass(state.composicaoPrimeira.fat_weight === 0 ? 0 : parseFloat(state.composicaoAtual.fat_weight) - parseFloat(state.composicaoPrimeira.fat_weight))">
                                {{ state.composicaoPrimeira.fat_weight === 0 ? 0 : (parseFloat(state.composicaoAtual.fat_weight) - parseFloat(state.composicaoPrimeira.fat_weight)).toFixed(2) }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-start row-label">{{$t('leanWeight')}}</td>
                            <td class="col-atual"><span class="valor-destaque">{{ (pesoMagro(state.composicaoAtual, somaAtual)).toFixed(2) }}</span></td>
                            <td>{{ somaPrimeiro === 0 ? 0 : (pesoMagro(state.composicaoPrimeira, somaPrimeiro)).toFixed(2) }}</td>
                            <td>{{ somaAnterior === 0 ? 0 : (pesoMagro(state.composicaoAnterior, somaAnterior)).toFixed(2) }}</td>
                            <td>
                                <span :class="diffClass(somaAnterior === 0 ? 0 : (pesoMagro(state.composicaoAtual, somaAtual)) - (pesoMagro(state.composicaoAnterior, somaAnterior)))">
                                {{ somaAnterior === 0 ? 0 :
                                    ((pesoMagro(state.composicaoAtual, somaAtual)) -
                                    (pesoMagro(state.composicaoAnterior, somaAnterior) )).toFixed(2)
                                }}
                                </span>
                            </td>
                            <td>
                                <span :class="diffClass(state.composicaoPrimeira.weight > 0 && pesoGordura(state.composicaoPrimeira, somaAnterior) > 0 ? (pesoMagro(state.composicaoAtual, somaAtual)) - (pesoMagro(state.composicaoPrimeira, somaAnterior)) : 0)">
                                {{
                                state.composicaoPrimeira.weight > 0 && pesoGordura(state.composicaoPrimeira, somaAnterior) > 0 ?
                                    ((pesoMagro(state.composicaoAtual, somaAtual)) -
                                    (pesoMagro(state.composicaoPrimeira, somaAnterior) )).toFixed(2) : 0
                                }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-start row-label">{{$t('basalMetabolicRate')}}</td>
                            <td class="col-atual"><span class="valor-destaque">{{ composicaoCorporal.basalMetabolicRate(state.composicaoAtual.weight, state.composicaoAtual.height, state.composicaoAtual.age, sexo) }}</span></td>
                            <td>{{ state.composicaoPrimeira.height === 0 ? 0 : composicaoCorporal.basalMetabolicRate(state.composicaoPrimeira.weight, state.composicaoPrimeira.height, state.composicaoPrimeira.age, sexo) }}</td>
                            <td>{{ state.composicaoAnterior.height === 0 ? 0 : composicaoCorporal.basalMetabolicRate(state.composicaoAnterior.weight, state.composicaoAnterior.height, state.composicaoAnterior.age, sexo) }}</td>
                            <td>
                                <span :class="diffClass(state.composicaoAnterior.height === 0 ? 0 : composicaoCorporal.basalMetabolicRate(state.composicaoAtual.weight, state.composicaoAtual.height, state.composicaoAtual.age, sexo) - composicaoCorporal.basalMetabolicRate(state.composicaoAnterior.weight, state.composicaoAnterior.height, state.composicaoAnterior.age, sexo))">
                                {{ state.composicaoAnterior.height === 0 ? 0 :
                                    (composicaoCorporal.basalMetabolicRate(state.composicaoAtual.weight, state.composicaoAtual.height, state.composicaoAtual.age, sexo) -
                                    composicaoCorporal.basalMetabolicRate(state.composicaoAnterior.weight, state.composicaoAnterior.height, state.composicaoAnterior.age, sexo)).toFixed(2)
                                }}
                                </span>
                            </td>
                            <td>
                                <span :class="diffClass(state.composicaoPrimeira.height === 0 ? 0 : composicaoCorporal.basalMetabolicRate(state.composicaoAtual.weight, state.composicaoAtual.height, state.composicaoAtual.age, sexo) - composicaoCorporal.basalMetabolicRate(state.composicaoPrimeira.weight, state.composicaoPrimeira.height, state.composicaoPrimeira.age, sexo))">
                                {{ state.composicaoPrimeira.height === 0 ? 0 :
                                    (composicaoCorporal.basalMetabolicRate(state.composicaoAtual.weight, state.composicaoAtual.height, state.composicaoAtual.age, sexo) -
                                    composicaoCorporal.basalMetabolicRate(state.composicaoPrimeira.weight, state.composicaoPrimeira.height, state.composicaoPrimeira.age, sexo)).toFixed(2)
                                }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-start row-label">{{$t('mmMetabolicRate')}}</td>
                            <td class="col-atual">
                                <span class="valor-destaque">{{
                                    composicaoCorporal.mmMetabolicRate(
                                        pesoMagro(state.composicaoAtual, somaAtual),
                                        state.composicaoAtual.height, state.composicaoAtual.age, sexo)
                                }}</span>
                            </td>
                            <td>{{ somaPrimeiro === 0 ? 0 : composicaoCorporal.mmMetabolicRate(pesoMagro(state.composicaoPrimeira, somaPrimeiro), state.composicaoPrimeira.height, state.composicaoPrimeira.age, sexo) }}</td>
                            <td>{{ somaAnterior === 0 ? 0 : composicaoCorporal.mmMetabolicRate(pesoMagro(state.composicaoAnterior, somaAnterior), state.composicaoAnterior.height, state.composicaoAnterior.age, sexo) }}</td>
                            <td>
                                <span :class="diffClass(somaAnterior === 0 ? 0 : composicaoCorporal.mmMetabolicRate(pesoMagro(state.composicaoAtual, somaAtual), state.composicaoAtual.height, state.composicaoAtual.age, sexo) - composicaoCorporal.mmMetabolicRate(pesoMagro(state.composicaoAnterior, somaAnterior), state.composicaoAnterior.height, state.composicaoAnterior.age, sexo))">
                                {{ somaAnterior === 0 ? 0 :
                                    (composicaoCorporal.mmMetabolicRate(pesoMagro(state.composicaoAtual, somaAtual), state.composicaoAtual.height, state.composicaoAtual.age, sexo) -
                                    composicaoCorporal.mmMetabolicRate(pesoMagro(state.composicaoAnterior, somaAnterior), state.composicaoAnterior.height, state.composicaoAnterior.age, sexo)).toFixed(2)
                                }}
                                </span>
                            </td>
                            <td>
                                <span :class="diffClass(somaPrimeiro === 0 ? 0 : composicaoCorporal.mmMetabolicRate(pesoMagro(state.composicaoAtual, somaAtual), state.composicaoAtual.height, state.composicaoAtual.age, sexo) - composicaoCorporal.mmMetabolicRate(pesoMagro(state.composicaoPrimeira, somaPrimeiro), state.composicaoPrimeira.height, state.composicaoPrimeira.age, sexo))">
                                {{ somaPrimeiro === 0 ? 0 :
                                    (composicaoCorporal.mmMetabolicRate(pesoMagro(state.composicaoAtual, somaAtual), state.composicaoAtual.height, state.composicaoAtual.age, sexo) -
                                    composicaoCorporal.mmMetabolicRate(pesoMagro(state.composicaoPrimeira, somaPrimeiro), state.composicaoPrimeira.height, state.composicaoPrimeira.age, sexo)).toFixed(2)
                                }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-start row-label">{{$t('bmi')}}</td>
                            <td class="col-atual"><span class="valor-destaque">{{ composicaoCorporal.imc(state.composicaoAtual.weight, state.composicaoAtual.height) }}</span></td>
                            <td>{{ composicaoCorporal.imc(state.composicaoPrimeira.weight, state.composicaoPrimeira.height) }}</td>
                            <td>{{ composicaoCorporal.imc(state.composicaoAnterior.weight, state.composicaoAnterior.height) }}</td>
                            <td>
                                <span :class="diffClass(state.composicaoAnterior.weight === 0 ? 0 : composicaoCorporal.imc(state.composicaoAtual.weight, state.composicaoAtual.height) - composicaoCorporal.imc(state.composicaoAnterior.weight, state.composicaoAnterior.height))">
                                {{ state.composicaoAnterior.weight === 0 ? 0 :
                                    (composicaoCorporal.imc(state.composicaoAtual.weight, state.composicaoAtual.height) -
                                    composicaoCorporal.imc(state.composicaoAnterior.weight, state.composicaoAnterior.height)).toFixed(2)
                                }}
                                </span>
                            </td>
                            <td>
                                <span :class="diffClass(state.composicaoPrimeira.weight === 0 ? 0 : composicaoCorporal.imc(state.composicaoAtual.weight, state.composicaoAtual.height) - composicaoCorporal.imc(state.composicaoPrimeira.weight, state.composicaoPrimeira.height))">
                                {{ state.composicaoPrimeira.weight === 0 ? 0 :
                                    (composicaoCorporal.imc(state.composicaoAtual.weight, state.composicaoAtual.height) -
                                    composicaoCorporal.imc(state.composicaoPrimeira.weight, state.composicaoPrimeira.height)).toFixed(2)
                                }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-start row-label">{{$t('cardiacRisk')}}</td>
                            <td class="col-atual"><span class="valor-destaque">{{ riscoCardiaco(state.circAtual, state.composicaoAtual) }}</span></td>
                            <td>{{ riscoCardiaco(state.circPrimeira, state.composicaoPrimeira) }}</td>
                            <td>{{ riscoCardiaco(state.circAnterior, state.composicaoAnterior) }}</td>
                            <td>-</td>
                            <td>-</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
  </template>

  <script>
  import {reactive, onMounted, ref, inject, computed, watch, nextTick} from 'vue'
  import {useRoute, useRouter} from "vue-router";
  import {useStore} from "vuex";
  import ComposiaoCorporalModel from "@/models/composicaoCorporalModel";
  import Chart from "chart.js/auto";

  import alunoRepository from "@/services/api/alunoRepository";
  import circunferenciaRepository from "@/services/api/composicaoCorporalCircunferenciaRepository";
  import * as composicaoCorporal from "../../../../../services/composicaoCorporal.service";
  export default {
      name: "ResultadosComponent",
    computed: {
      composicaoCorporal() {
        return composicaoCorporal
      }
    },

      props: {
          medidaAtualProp: {
              type: Object,
              default: null
          },
          medidaAnteriorProp: {
              type: Object,
              default: null
          },
          medidaPrimeiraProp: {
              type: Object,
              default: null
          },
        calculaMedidasProp: {
            type: Boolean,
            default: true
        }
      },
      setup(props) {
          const router = useRouter()
          const route = useRoute()
          const swal = inject('$swal')
          const store = useStore()

          onMounted( () => {
            state.composicaoAtual = props.medidaAtualProp ? props.medidaAtualProp : new ComposiaoCorporalModel()
            state.composicaoAnterior = props.medidaAnteriorProp ? props.medidaAnteriorProp : new ComposiaoCorporalModel()
            state.composicaoPrimeira = props.medidaPrimeiraProp ? props.medidaPrimeiraProp : new ComposiaoCorporalModel()
            buscaDadosAluno()
            buscaCircunferencia()

          })

        async function buscaDadosAluno() {
          alunoRepository.AlunoGetCurrent().then(response => {
            // data vem null quando o header student-manager nao resolve um aluno.
            // Antes o codigo seguia e estourava em state.aluno.age.
            if(response.data.success && response.data.data) {
              state.aluno = response.data.data
              if(state.composicaoAtual && state.composicaoAtual.age == 0 && state.aluno.age != null) {
                state.composicaoAtual.age = state.aluno.age
              }
            }
          }).catch (error => {
            store.commit('SET_SPLASH_SCREEN', false)
            console.error(error)
          }).finally(() => {
            store.commit('SET_SPLASH_SCREEN', false)
          })
        }

        const state = reactive({
            composicaoAtual: new ComposiaoCorporalModel(),
            composicaoAnterior: new ComposiaoCorporalModel(),
            composicaoPrimeira: new ComposiaoCorporalModel(),
            dadosSalvos: false,
            aluno: null,
            bodyFat: 0,
            circAtual: {},
            circAnterior: {},
            circPrimeira: {}
        })

        // Busca cintura/quadril (circunferencia) da avaliacao p/ o Risco Cardiaco (RCQ)
        async function buscaCircunferencia() {
          const assessmentId = state.composicaoAtual.student_physical_assessment_id
          if (!assessmentId) return
          try {
            const resp = await circunferenciaRepository.CircunferenciaGetByAssessmentId(assessmentId)
            if (resp.data.success && resp.data.data) {
              const d = resp.data.data
              state.circAtual = d.item || {}
              state.circAnterior = d.before || {}
              state.circPrimeira = d.first || {}
            }
          } catch (e) {
            // sem circunferencia cadastrada - risco fica '-'
          }
        }

        // Retorna "0.92 (ALTO)" ou "-"
        function riscoCardiaco(circ, composicao) {
          if (!circ) return '-'
          const r = composicaoCorporal.cardiacRisk(circ.circ_waist, circ.circ_hip, sexo.value, composicao.age)
          return r.classification === '-' ? '-' : `${r.value} (${r.classification})`
        }

        const somaAtual = computed (() => {
          const response = parseInt(state.composicaoAtual.sub_scapular) +
                parseInt(state.composicaoAtual.triceps) +
                parseInt(state.composicaoAtual.biceps) +
                parseInt(state.composicaoAtual.chest) +
                parseInt(state.composicaoAtual.mid_axillary) +
                parseInt(state.composicaoAtual.suprailiac) +
                parseInt(state.composicaoAtual.abdomen) +
                parseInt(state.composicaoAtual.thigh) +
                parseInt(state.composicaoAtual.leg)
          return isNaN(response) ? 0 : response
        })

        const somaPrimeiro = computed (() => {
          const response = parseInt(state.composicaoPrimeira.sub_scapular) +
                parseInt(state.composicaoPrimeira.triceps) +
                parseInt(state.composicaoPrimeira.biceps) +
                parseInt(state.composicaoPrimeira.chest) +
                parseInt(state.composicaoPrimeira.mid_axillary) +
                parseInt(state.composicaoPrimeira.suprailiac) +
                parseInt(state.composicaoPrimeira.abdomen) +
                parseInt(state.composicaoPrimeira.thigh) +
                parseInt(state.composicaoPrimeira.leg)
          return isNaN(response) ? 0 : response
        })

        const somaAnterior = computed (() => {
          const response = parseInt(state.composicaoAnterior.sub_scapular) +
                parseInt(state.composicaoAnterior.triceps) +
                parseInt(state.composicaoAnterior.biceps) +
                parseInt(state.composicaoAnterior.chest) +
                parseInt(state.composicaoAnterior.mid_axillary) +
                parseInt(state.composicaoAnterior.suprailiac) +
                parseInt(state.composicaoAnterior.abdomen) +
                parseInt(state.composicaoAnterior.thigh) +
                parseInt(state.composicaoAnterior.leg)
          return isNaN(response) ? 0 : response
        })

        // Sexo do aluno para as formulas de TMB (Mifflin). Default 'M' se ainda nao carregou.
        const sexo = computed(() => (state.aluno && state.aluno.sex) ? state.aluno.sex : 'M')

        // num() aceita virgula: "66,10" -> 66.10 (evita NaN nos calculos)
        const num = composicaoCorporal.n

        function pesoGordura(item, soma) {
            const fatPct = num(state.composicaoAtual.fat_percentage)
            if(fatPct > 0) {
              return (num(item.weight) * fatPct / 100).toFixed(2)
            }
          const bodyFat = composicaoCorporal.percentageBodyFatPollock(item.age, soma)
          return ((num(item.weight) * num(bodyFat)) / 100).toFixed(2)
        }

        // Peso magro robusto (peso - peso de gordura), aceitando virgula
        function pesoMagro(item, soma) {
          return parseFloat(composicaoCorporal.skinnyWeight(item.weight, pesoGordura(item, soma)))
        }

        function pesoGorduraAtual() {
          const weight = parseFloat(state.composicaoAtual.weight)
          const pollock = parseFloat(state.composicaoAtual.fat_percentage)
          let fatWeight = ((weight * pollock) / 100).toFixed(2)
          state.composicaoAtual.fat_weight = fatWeight
        }

        watch(props, (newValue, oldValue) => {
          pesoGorduraAtual()
          // Recarrega cintura/quadril quando os dados da avaliacao chegam (evita risco '-' por timing)
          buscaCircunferencia()
        })

        function fatPercentageAtual() {
          state.composicaoAtual.fat_percentage = composicaoCorporal.percentageBodyFatPollock(state.composicaoAtual.age, somaAtual.value)
        }

        function diffClass(value) {
          const num = parseFloat(value)
          if (isNaN(num) || num === 0) return 'diff-zero'
          return num > 0 ? 'diff-positive' : 'diff-negative'
        }

        const showChart = ref(false)
        const resultadosChartCanvas = ref(null)
        let chartInstance = null

        watch(showChart, async (val) => {
          if (val) {
            await nextTick()
            renderChart()
          } else {
            if (chartInstance) {
              chartInstance.destroy()
              chartInstance = null
            }
          }
        })

        function renderChart() {
          if (!resultadosChartCanvas.value) return
          if (chartInstance) {
            chartInstance.destroy()
          }
          const ctx = resultadosChartCanvas.value.getContext('2d')
          const labels = ['Peso (kg)', '% Gordura', 'Peso Gordo', 'Peso Magro', 'IMC']
          const leanAtual = (pesoMagro(state.composicaoAtual, somaAtual.value))
          const leanPrimeira = somaPrimeiro.value === 0 ? 0 : (pesoMagro(state.composicaoPrimeira, somaPrimeiro.value))
          const leanAnterior = somaAnterior.value === 0 ? 0 : (pesoMagro(state.composicaoAnterior, somaAnterior.value))

          const dataAtual = [
            parseFloat(state.composicaoAtual.weight) || 0,
            parseFloat(state.composicaoAtual.fat_percentage) || 0,
            parseFloat(state.composicaoAtual.fat_weight) || 0,
            parseFloat(leanAtual) || 0,
            parseFloat(composicaoCorporal.imc(state.composicaoAtual.weight, state.composicaoAtual.height)) || 0
          ]
          const dataPrimeira = [
            parseFloat(state.composicaoPrimeira.weight) || 0,
            parseFloat(state.composicaoPrimeira.fat_percentage) || 0,
            parseFloat(state.composicaoPrimeira.fat_weight) || 0,
            parseFloat(leanPrimeira) || 0,
            parseFloat(composicaoCorporal.imc(state.composicaoPrimeira.weight, state.composicaoPrimeira.height)) || 0
          ]
          const dataAnterior = [
            parseFloat(state.composicaoAnterior.weight) || 0,
            parseFloat(state.composicaoAnterior.fat_percentage) || 0,
            parseFloat(state.composicaoAnterior.fat_weight) || 0,
            parseFloat(leanAnterior) || 0,
            parseFloat(composicaoCorporal.imc(state.composicaoAnterior.weight, state.composicaoAnterior.height)) || 0
          ]

          chartInstance = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: labels,
              datasets: [
                {
                  label: 'Atual',
                  data: dataAtual,
                  backgroundColor: '#F7941D',
                  borderColor: '#F7941D',
                  borderWidth: 2,
                  borderRadius: 6,
                },
                {
                  label: 'Primeira',
                  data: dataPrimeira,
                  backgroundColor: '#2D3A7C',
                  borderColor: '#2D3A7C',
                  borderWidth: 2,
                  borderRadius: 6,
                },
                {
                  label: 'Anterior',
                  data: dataAnterior,
                  backgroundColor: '#7B8ABF',
                  borderColor: '#7B8ABF',
                  borderWidth: 2,
                  borderRadius: 6,
                }
              ]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: true,
                  position: 'top',
                  labels: {
                    font: { size: 13, weight: 'bold' },
                    padding: 16,
                    usePointStyle: true,
                    pointStyle: 'circle'
                  }
                },
                tooltip: {
                  backgroundColor: '#2D3A7C',
                  titleFont: { size: 13 },
                  bodyFont: { size: 12 },
                  padding: 10,
                  cornerRadius: 8,
                }
              },
              scales: {
                y: {
                  beginAtZero: true,
                  grid: { color: 'rgba(45,58,124,0.08)' },
                  ticks: { font: { size: 11 }, color: '#344767' }
                },
                x: {
                  grid: { display: false },
                  ticks: { font: { size: 11, weight: 'bold' }, color: '#2D3A7C' }
                }
              }
            }
          })
        }

          return {
              state,
              sexo,
              riscoCardiaco,
              somaAtual,
              somaPrimeiro,
              somaAnterior,
              pesoGordura,
              pesoMagro,
              diffClass,
              showChart,
              resultadosChartCanvas
          }
      }
  }
  </script>

  <style scoped>
  .resultado-container {
    margin-top: 16px;
    border: 2px solid #2D3A7C;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(45, 58, 124, 0.15);
  }
  .resultado-header {
    background: linear-gradient(135deg, #2D3A7C 0%, #3B4A8C 100%);
    color: #fff;
    font-weight: 700;
    font-size: 1rem;
    padding: 12px 18px;
    letter-spacing: 0.3px;
    box-shadow: 0 4px 12px rgba(45, 58, 124, 0.3);
  }
  .resultado-table {
    font-size: 0.85rem;
  }
  .resultado-table thead th {
    background: linear-gradient(135deg, #2D3A7C 0%, #3B4A8C 100%) !important;
    color: #fff !important;
    font-weight: 700;
    font-size: 0.78rem;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    padding: 10px 8px;
    border-color: #354585 !important;
    white-space: nowrap;
  }
  .resultado-table tbody td {
    padding: 10px 8px;
    vertical-align: middle;
    border-bottom: 1px solid #e8eaf0;
    color: #344767;
  }
  .resultado-table tbody tr:nth-child(even) {
    background: #f0f2f7;
  }
  .resultado-table tbody tr:hover {
    background: #ebeff5;
  }
  .col-label {
    width: 25%;
  }
  .col-atual {
    background: rgba(45, 58, 124, 0.05) !important;
  }
  .row-label {
    font-weight: 600;
    color: #2D3A7C;
    font-size: 0.83rem;
  }
  .valor-destaque {
    display: inline-block;
    background: #F7941D;
    color: #fff;
    font-weight: 700;
    font-size: 0.85rem;
    padding: 3px 14px;
    border-radius: 8px;
    min-width: 50px;
    text-align: center;
    box-shadow: 0 2px 6px rgba(247, 148, 29, 0.3);
  }
  .diff-positive {
    display: inline-block;
    background: rgba(45, 206, 137, 0.12);
    color: #2dce89;
    font-weight: 700;
    font-size: 0.82rem;
    padding: 2px 10px;
    border-radius: 12px;
  }
  .diff-positive::before {
    content: '+';
  }
  .diff-negative {
    display: inline-block;
    background: rgba(245, 54, 92, 0.1);
    color: #f5365c;
    font-weight: 700;
    font-size: 0.82rem;
    padding: 2px 10px;
    border-radius: 12px;
  }
  .diff-zero {
    display: inline-block;
    background: rgba(131, 146, 171, 0.1);
    color: #8392ab;
    font-weight: 500;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 0.82rem;
  }
  /* Chart button */
  .btn-chart-toggle {
    background: rgba(255,255,255,0.15);
    border: 2px solid rgba(255,255,255,0.4);
    color: #fff;
    padding: 5px 16px;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
  }
  .btn-chart-toggle:hover {
    background: #F7941D;
    border-color: #F7941D;
    box-shadow: 0 2px 8px rgba(247,148,29,0.4);
  }
  /* Chart overlay/modal */
  .chart-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(3px);
  }
  .chart-modal {
    background: #fff;
    border-radius: 16px;
    width: 90%;
    max-width: 800px;
    box-shadow: 0 20px 60px rgba(0,0,0,0.3);
    overflow: hidden;
    animation: chartSlideIn 0.3s ease;
  }
  @keyframes chartSlideIn {
    from { transform: translateY(30px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
  .chart-modal-header {
    background: linear-gradient(135deg, #2D3A7C 0%, #3B4A8C 100%);
    color: #fff;
    padding: 14px 20px;
    font-weight: 700;
    font-size: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .btn-chart-close {
    background: rgba(255,255,255,0.15);
    border: none;
    color: #fff;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    cursor: pointer;
    font-size: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
  }
  .btn-chart-close:hover {
    background: #F7941D;
  }
  .chart-modal-body {
    padding: 24px;
    height: 400px;
  }
  </style>